var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-input",
    {
      attrs: {
        "float-label": _vm.placeholder,
        clearable: "",
        disable: _vm.disable
      },
      on: { clear: _vm.clear, input: _vm.clear },
      model: {
        value: _vm.searchQuery,
        callback: function($$v) {
          _vm.searchQuery = $$v
        },
        expression: "searchQuery"
      }
    },
    [
      _c("q-autocomplete", {
        attrs: { "min-characters": _vm.minCharacters, "max-results": 20 },
        on: { search: _vm.runSearch, selected: _vm.itemSelected }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }